import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { BreadCrumb } from '../routes/BreadCrumbs/ingresse.breadcrumb';
import { default as BreadCrumbs, default as breadCrumbsList } from '../routes/breadCrumbsList';
import { BreadCrumbExtends } from './contexts/breadCrumb.context';

const DEFAULT_BREADCRUMBS = BreadCrumbs[0][1];

function useBreadcrumbSelector(producerId: number) {
  const location = useLocation();
  const [breadCrumbs, setBreadcrumbs] = useState<BreadCrumbExtends[]>([]);
  const [activeRoute, setActiveRoute] = useState<string>('');

  const currentPath = location.pathname.split('/')[1];

  /**
   * Finds the appropriate breadcrumbs for the given producer ID and updates the state.
   * - Searches for the theme corresponding to the producer ID.
   * - Maps the breadcrumbs to mark the current path as active.
   * - If no theme is found, defaults to the predefined breadcrumbs.
   * - Sets the breadcrumbs and active route state.
  */
  useEffect(() => {
    const theme = breadCrumbsList.find((theme) => Number(Object.keys(theme)[0]) === producerId);
    const themeBreadcrumbs = theme
      ? Object.values(theme)[0].map((breadcrumb: BreadCrumb) => ({
        ...breadcrumb,
        active : breadcrumb.route.includes(currentPath),
      }))
      : DEFAULT_BREADCRUMBS.map((breadcrumb: BreadCrumb) => ({
        ...breadcrumb,
        active : breadcrumb.route.includes(currentPath),
      }));

    setBreadcrumbs(themeBreadcrumbs);
    setActiveRoute(currentPath);
  }, [location.pathname, producerId, currentPath]);

  return { breadCrumbs, activeRoute };
}

export default useBreadcrumbSelector;
